import React from 'react'

const Homerecruitment = () => {
  return (
    <section id="more-features" className="more-features section">
      <div className="container">
        <div className="row justify-content-around gy-4">
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2 order-lg-1">
            <h3>Recruitment Management</h3>
            <p /><p>Accomplish the high-volume process of sourcing, tracking and recruiting the best talent that is aligned with your business – on a single, comprehensive, centralized platform.</p><p />
            <div className="row">
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-easel flex-shrink-0" />
                <div>
                  <p>Efficient &amp; Flexible Hiring</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-patch-check flex-shrink-0" />
                <div>
                  <p>Digital Offer Process Management</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Tracking &amp; Analytics</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Letters &amp; Mail Merge</p>
                </div>
              </div>{/* End Icon Box */}
            </div>
          </div>
          <div className="features-image col-lg-5 order-1 order-lg-2">
            <img src="https://sigohrmlpadmin.loopring.in/front/images/homerecruitmentmanagements/41174.png" alt />
          </div>
        </div>
      </div>
    </section>

  )
}

export default Homerecruitment
